import api from './index.js'

export default {

  // ユーザー情報を取得
  getUser() {
    return api.get('user.json')
  },

  // ユーザー情報を更新
  updateUser(params) {
    return api.patch('user.json', params)
  },

  // ユーザー画像を更新
  updateUserThumb(params) {
    return api.patch('user/upload_thumb.json', params)
  },

  // 管理者作成依頼メールを送信
  sendManagerRequest(name, email) {
    let params = {
      name: name,
      email: email
    }
    return api.post('manager_request.json', params)
  },

  requestPasswordReset(email) {
    return api.post('register/request_password_reset', { email });
  },

  verifyManagerRequest(email, token) {
    let params = {
      email,
      token
    };
    return api.get('register/validate_registration_token', params);
  },

  // 管理者登録の依頼メールのリンクからのアクセスが正しいか検証
  validatePasswordResetToken(email, token) {
    let params = {
      email,
      token
    };
    return api.get('register/validate_password_reset_token', params);
  },

  // 管理者を有効化
  resetPassword(email, new_password, token) {
    let params = {
      email,
      new_password,
      token
    };
    return api.post('register/reset_password.json', params);
  },

  // 管理者情報を更新
  updateManager(payload) {
    return api.patch(`managers/${payload.id}.json`, payload.params)
  },

  // 管理者情報を削除
  deleteManager(id) {
    return api.delete(`managers/${id}.json`)
  },

  // 管理者一覧を取得
  getManagers() {
    return api.get('managers.json')
  },

  // ユーザーにサービスを紐付け
  createUserServiceRelationship(params) {
    return api.post('service.json', params)
  },

  // ユーザーに紐付いたサービスを更新
  updateUserServiceRelationship(payload) {
    return api.patch(`service/${payload.service_key}.json`, payload.params)
  },

  // ユーザーに紐付いたサービスを削除
  deleteUserServiceRelationship(service_key) {
    return api.delete(`service/${service_key}.json`)
  },

  // CUONA購入申請をマネージャーからオーナーへ送る
  createDeviceRequest(payload) {
    return api.post('device_requests.json', payload)
  },

  // CUONA購入申請を削除
  deleteDeviceRequest(id) {
    return api.delete(`device_requests/${id}.json`)
  },

  // CUONA購入申請を取得
  getDeviceRequests() {
    return api.get('device_requests.json')
  },

  // stripeでの購入処理
  createCharges(params) {
    return api.post('charges.json', params)
  }
}
